// import { useEffect, useState } from "react";
// import {
//   AppShell,
//   Text,
//   Burger,
//   Group,
//   Avatar,
//   useMantineTheme,
// } from "@mantine/core";
// import {
//   IconCurrency,
//   IconFile,
//   IconLogout,
//   IconPlane,
//   IconPlaneArrival,
//   IconPlaneDeparture,
//   IconPlaneInflight,
//   IconReportMoney,
//   IconUser,
//   IconUserCircle,
// } from "@tabler/icons-react";
// import { getGroup } from "../misc/tokens";
// import { getRulesRead } from "../misc/api";

// export function LoggedInContainer({ children, setTr }) {
//   const theme = useMantineTheme();
//   const [opened, setOpened] = useState(false);
//   const [readTerms, setTerms] = useState(false);

//   const admin = getGroup() === "0";

//   useEffect(() => {
//     getRulesRead().then((x) => {
//       setTerms(x);
//       setTr && setTr(!x);
//     });
//   }, []);

//   return (
//     <AppShell
//       navbar={{
//         width: 250,
//         breakpoint: "sm",
//         collapsed: { mobile: !opened },
//       }}
//       header={{ height: 70 }}
//       padding="md"
//     >
//       <AppShell.Header>
//         <Group h="100%" px="md">
//           <Burger
//             opened={opened}
//             onClick={() => setOpened((o) => !o)}
//             hiddenFrom="sm"
//             size="sm"
//             color={theme.colors.gray[6]}
//           />
//           <a href="/main" style={{ textDecoration: "none", color: "black" }}>
//             <h2>Spilve airport</h2>
//           </a>
//         </Group>
//       </AppShell.Header>

//       <AppShell.Navbar p="md">
//         {admin && (
//           <NavButton icon={<IconUserCircle />} label="Admin" link="/admin" />
//         )}
//         {admin && (
//           <NavButton
//             icon={<IconPlaneInflight />}
//             label="Airfield info"
//             link="/flight-data"
//           />
//         )}

//         <NavButton
//           icon={<IconFile />}
//           label="Spilve flight info"
//           link="/rules"
//         />

//         <NavButton
//           icon={<IconCurrency />}
//           label="Buy Credits"
//           link="/buy-credits"
//           disabled={!readTerms}
//         />
//         <NavButton
//           icon={<IconPlane />}
//           label="My Aircraft info"
//           link="/planes"
//           disabled={!readTerms}
//         />
//         <NavButton
//           icon={<IconPlaneDeparture />}
//           label="Request flight"
//           link="/request"
//           disabled={!readTerms}
//         />
//         <NavButton
//           icon={<IconPlaneArrival />}
//           label="Flight history"
//           link="/flight-history"
//           disabled={!readTerms}
//         />
//         <NavButton
//           icon={<IconReportMoney />}
//           label="Payment history"
//           link="/payment-history"
//           disabled={!readTerms}
//         />
//         <NavButton icon={<IconUser />} label="My profile" link="/profile" />
//         <NavButton
//           icon={
//             <Avatar size={40} color="blue">
//               <IconLogout />
//             </Avatar>
//           }
//           label="Logout"
//           link="/logout"
//         />
//       </AppShell.Navbar>

//       <AppShell.Main>{children}</AppShell.Main>
//     </AppShell>
//   );
// }

// function NavButton({ icon, label, link, disabled }) {
//   return (
//     <button
//       onClick={() => !disabled && (window.location.href = link)}
//       style={{
//         width: 220,
//         padding: 10,
//         marginBottom: 5,
//         display: "flex",
//         alignItems: "center",
//         border: "none",
//         background: "transparent",
//         cursor: disabled ? "default" : "pointer",
//         color: disabled ? "gray" : "black",
//         borderBottom: "0.1px solid lightgrey",
//       }}
//     >
//       <Group>
//         {icon}
//         <Text>{label}</Text>
//       </Group>
//     </button>
//   );
// }

import { useEffect, useState } from "react";
import {
  AppShell,
  Text,
  Burger,
  Group,
  Avatar,
  useMantineTheme,
} from "@mantine/core";
import {
  IconCurrency,
  IconFile,
  IconLogout,
  IconPlane,
  IconPlaneArrival,
  IconPlaneDeparture,
  IconPlaneInflight,
  IconReportMoney,
  IconUser,
  IconUserCircle,
  IconFileReport,
} from "@tabler/icons-react";
import { getGroup } from "../misc/tokens";
import { getRulesRead } from "../misc/api";

export function LoggedInContainer({ children, setTr }) {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const [readTerms, setTerms] = useState(false);

  const group = getGroup();
  const admin = group === "0";
  const dezurants = group === "100";
  const hasElevatedAccess = admin || dezurants;

  useEffect(() => {
    getRulesRead().then((x) => {
      setTerms(x);
      setTr && setTr(!x);
    });
  }, []);

  return (
    <AppShell
      navbar={{
        width: 250,
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
      header={{ height: 70 }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md">
          <Burger
            opened={opened}
            onClick={() => setOpened((o) => !o)}
            hiddenFrom="sm"
            size="sm"
            color={theme.colors.gray[6]}
          />
          <a href="/main" style={{ textDecoration: "none", color: "black" }}>
            <h2>Spilve airport</h2>
          </a>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        {hasElevatedAccess && (
          <NavButton icon={<IconUserCircle />} label={admin ? "Admin" : "Dežurants"} link="/admin" />
        )}
        {hasElevatedAccess && (
          <NavButton
            icon={<IconPlaneInflight />}
            label="Airfield info"
            link="/flight-data"
          />
        )}

        {admin && (
          <NavButton
            icon={<IconFileReport />}
            label="Invoice Reports"
            link="/admin-reports"
          />
        )}

        <NavButton
          icon={<IconFile />}
          label="Spilve flight info"
          link="/rules"
        />

        <NavButton
          icon={<IconCurrency />}
          label="Buy Credits"
          link="/buy-credits"
          disabled={!readTerms}
        />
        <NavButton
          icon={<IconPlane />}
          label="My Aircraft info"
          link="/planes"
          disabled={!readTerms}
        />
        <NavButton
          icon={<IconPlaneDeparture />}
          label="Request flight"
          link="/request"
          disabled={!readTerms}
        />
        <NavButton
          icon={<IconPlaneArrival />}
          label="Flight history"
          link="/flight-history"
          disabled={!readTerms}
        />
        <NavButton
          icon={<IconReportMoney />}
          label="Payment history"
          link="/payment-history"
          disabled={!readTerms}
        />
        <NavButton icon={<IconUser />} label="My profile" link="/profile" />
        <NavButton
          icon={
            <Avatar size={40} color="blue">
              <IconLogout />
            </Avatar>
          }
          label="Logout"
          link="/logout"
        />
      </AppShell.Navbar>

      <AppShell.Main>{children}</AppShell.Main>
    </AppShell>
  );
}

function NavButton({ icon, label, link, disabled }) {
  return (
    <button
      onClick={() => !disabled && (window.location.href = link)}
      style={{
        width: 220,
        padding: 10,
        marginBottom: 5,
        display: "flex",
        alignItems: "center",
        border: "none",
        background: "transparent",
        cursor: disabled ? "default" : "pointer",
        color: disabled ? "gray" : "black",
        borderBottom: "0.1px solid lightgrey",
      }}
    >
      <Group>
        {icon}
        <Text>{label}</Text>
      </Group>
    </button>
  );
}